import { toContent } from '@/utils/product'
import { useBundleStore, useProductsStore } from '@/stores'
import type { Product } from '@/types/shopify'

export const useBlotout = () => {
  const store = useProductsStore()
  const bundle = useBundleStore()

  const publish = (event: string, data: unknown) => {
    if (typeof window.Shopify?.analytics?.publish !== 'function') {
      return
    }
    window.Shopify.analytics.publish(event, data)
  }

  const productClicked = async (id: number) => {
    const product = store.productList.find(i => i.id === id)
    if (!product) {
      return
    }
    const data = toContent(product, 1, bundle.priceCents)
    publish('oats:product_clicked', {
      value: data.item_price,
      currency: 'USD',
      contents: [ data ]
    })
  }

  const addToCart = async (id: number) => {
    if (!window.edgetag) {
      return
    }
    const product = store.productList.find(i => i.id === id)
    if (!product) {
      return
    }
    const data = toContent(product, 1, bundle.priceCents)
    window.edgetag('tag', 'AddToCart', {
      value: data.item_price,
      currency: 'USD',
      contents: [ data ]
    })
  }

  const productViewed = async (product: Product, url: string) => {
    const data = toContent(product, 1, bundle.priceCents)
    data.url = url
    publish('oats:view_content', {
      value: data.item_price,
      currency: 'USD',
      contents: [ data ]
    })
  }

  return {
    productClicked,
    addToCart,
    productViewed
  }
}
